interface DeploymentDetailsProps {
  hidden?: boolean;
}

const DeploymentDetails = ({ hidden }: DeploymentDetailsProps) => {
  if (hidden) {
    return null;
  }

  return (
    <div className="hidden md:block fixed bottom-32 right-5 border border-gray-200 shadow-xl bg-gray-50">
      <div className="bg-red-500 text-white px-2 py-0.5">Non production only</div>
      <div className="p-2">
        <p>Branch: {process.env.REACT_APP_VERCEL_GIT_COMMIT_REF ?? '???'}</p>
        <p>SHA: {(process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA ?? '').substring(0, 7) ?? '???'}</p>
        <p>CM: {process.env.REACT_APP_VERCEL_GIT_COMMIT_MESSAGE ?? '???'}</p>
      </div>
    </div>
  );
};

export default DeploymentDetails;
